<template>
  <div class="statistical-page" ref="container">
    <div class="navs">
      <div class="list">
		<div
		  class="item"
		  :class="time == 'total' ? 'on' : ''"
		  @click="setTime('total')"
		>
		  全部
		</div>
        <div
          class="item"
          :class="time == 'today' ? 'on' : ''"
          @click="setTime('today')"
        >
          今天
        </div>
        <div
          class="item"
          :class="time == 'yesterday' ? 'on' : ''"
          @click="setTime('yesterday')"
        >
          昨天
        </div>
        <div
          class="item"
          :class="time == 'seven' ? 'on' : ''"
          @click="setTime('seven')"
        >
          最近7天
        </div>
        <!-- <div
          class="item"
          :class="time == 'month' ? 'on' : ''"
          @click="setTime('month')"
        >
          本月
        </div> -->
        <div
          class="item"
          :class="time == 'date' ? 'on' : ''"
          @click="dateTitle"
        >
          <!-- <span class="iconfont icon-xiangxia"></span>
          <span v-for="(value, index) in renderValues" :key="index">
            {{ value }}</span
          > -->
          自定义
        </div>
      </div>
    </div>

    <div class="public-wrapper public-wrapper-mon">
		<div class="public-wrapper-mon-top">
			<h2>{{ commissionData.commissionCount }}</h2>
			<p class="gray">累计收益</p>
			<p class="waitmon">待结算<strong>{{ commissionData.commissioSettled }}</strong>元</p>
		</div>
		<div class="public-wrapper-mon-bot">
			<div>
				<h2>{{ commissionData.goodsCount }}</h2>
				<p class="gray">商品佣金(元)</p>
				<p class="waitmon">待结算<strong>{{ commissionData.goodsSettled }}</strong>元</p>
			</div>
			<div>
				<h2>{{ commissionData.invitedCount }}</h2>
				<p class="gray">邀请奖励(元)</p>
				<p class="waitmon">待结算<strong>{{ commissionData.invitedSettled }}</strong>元</p>
			</div>
			<div v-if="commissionData.servicedisplay">
				<h2>{{ commissionData.serviceCount }}</h2>
				<p class="gray">服务奖励(元)</p>
				<p class="waitmon">待结算<strong>{{ commissionData.serviceSettled }}</strong>元</p>
			</div>
		</div>
    </div>
	<div class="public-wrapper public-wrapper-num">
		<div class="public-wrapper-num-l">
			<div>
				<h2>{{ commissionData.customerCount }}</h2>
				<p class="gray">累计客户(人)</p>
			</div>
			<div>
				<h2>{{ commissionData.orderCount }}</h2>
				<p class="gray">累计订单(笔)</p>
			</div>
		</div>
		<div class="public-wrapper-num-r">
			<h2>{{ commissionData.invitationCount }}</h2>
			<p class="gray">累计邀请(人)</p>
		</div>
	</div>
    <div class="calendar-wrapper" :class="current === true ? 'on' : ''">
      <div class="calendar">
        <Calendar
          :clean="clean"
          :lunar="lunar"
          ref="calendar"
          :range="isrange"
          :multi="ismulti"
          @select="select"
          @next="next"
          @prev="prev"
          :value="value"
          :weekSwitch="weekSwitch"
          :monthRange="monthRange"
          rangeMonthFormat="yyyy年MM月"
          monFirst
          responsive
          :begin="[1992, 5, 20]"
          :end="[2049, 5, 20]"
        />
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      v-show="current === true"
      @click="close"
    ></div>
  </div>
</template>
<script>
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
import { getStatisticsMonth, getStatisticsTime } from "../../../api/admin";
import { getCommissionDetails } from "@api/user";
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;
const day = new Date().getDate();
export default {
  name: "CommissionDetails",
  components: {
    Calendar
  },
  props: {},
  data: function() {
    return {
      value: [[year, month, day - 1], [year, month, day]],
      isrange: true,
      weekSwitch: false,
      ismulti: false,
      monFirst: true,
      clean: false, //简洁模式
      lunar: false, //显示农历
      renderValues: [],
      monthRange: [],
      current: false,
      where: {
        start: "",
        stop: "",
        type: ""
      },
	  timeData:0,
      time: "", //时间|today=今天|yesterday=昨天|month=本月
      title: "", //时间|today=今天|yesterday=昨天|month=本月
      commissionData: "", //佣金明细
      
    };
  },
  watch: {
    "$route.params": function(newVal) {
      var that = this;
      if (newVal != undefined) {
        // that.setType(newVal.type);
        that.setTime(newVal.time);
        that.getIndex();
      }
    }
  },
  mounted: function() {
    this.handelRenderValues();
    this.setTime(this.$route.params.time);
    // this.setType(this.$route.params.type);
    this.getIndex();
  },
  computed: {
    monthRangeText() {
      return this.monthRange.length ? "固定" : "指定范围";
    }
  },
  methods: {
    getIndex: function() {
      var that = this;
	  getCommissionDetails(that.timeData).then(res => {
		  that.commissionData = res.data;
	  }).catch(err => {
		  that.$dialog.error(error.msg);
		  setTimeout(function(){
		  	that.$router.push('/');  
		  },1000);
	  });
    },
    setTime: function(time) {
      this.time = time;
      var year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        day = new Date().getDate();
      switch (time) {
		case "total":
		  this.where.start =
		    new Date(Date.parse(2020 + "/" + 1 + "/" + 1)).getTime() /
		    1000;
		  this.where.stop =
		    new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
		      1000 +
		    24 * 60 * 60 -
		    1;
		  this.title = "全部";
		  this.timeData = 0;
		  this.getIndex();
		  break;
        case "today":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
            1000;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            1;
          this.title = "今日";
		  this.timeData = 'today';
          this.getIndex();
          break;
        case "yesterday":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 -
            24 * 60 * 60;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 -
            1;
          this.title = "昨日";
		  this.timeData = 'yesterday';
          this.getIndex();
          break;
        // case "month":
        //   this.where.start =
        //     new Date(year, new Date().getMonth(), 1).getTime() / 1000;
        //   this.where.stop = new Date(year, month, 1).getTime() / 1000 - 1;
        //   this.title = "本月";
        //   this.getIndex();
        //   break;
        case "seven":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            7 * 3600 * 24;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            1;
          this.title = "七日";
		  this.timeData = 'lately7';
          this.getIndex();
          break;
      }
    },
    // setType: function(type) {
    //   switch (type) {
    //     case "1":
    //       this.where.type = 1;
    //       break;
    //     case "2":
    //       this.where.type = 2;
    //       break;
    //   }
    // },
    clickSomeThing(data) {
      console.log(data);
      this.value = [[2019, 4, 1], [2019, 4, 8]];
    },
    setMonthRange() {
      this.monthRange = this.monthRange.length ? [] : ["2019-4", "2020-1"];
    },
    switchMode() {
      this.weekSwitch = !this.weekSwitch;
      setTimeout(() => {
        this.$refs.calendar.renderer(2019, 1); //渲染2018年8月份
      }, 0);
    },
    handelRenderValues(data) {
      if (this.ismulti) {
        this.renderValues = this.value.map(v => v.join("-"));
      } else if (this.isrange) {
        const values = [];
        data || this.value;
        this.value.forEach((v, i) => {
          values.push(v.join("-"));
          if (!i) {
            values.push("~");
          }
        });
        this.renderValues = values;
      } else {
        this.renderValues = [this.value.join("-")];
      }
    },
    multiMode() {
      this.ismulti = true;
      this.isrange = false;
      this.value = [[year, month, 16], [year, month, 18]];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    rangeMode() {
      this.ismulti = false;
      this.isrange = true;
      this.value = [[year, month, 16], [year, month, 22]];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    valueMode() {
      this.ismulti = false;
      this.isrange = false;
      this.value = [year, month, 16];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    selectMonth(month, year) {
      console.log(year, month);
    },
    prev(y, m, w) {
      console.log(y, m, w);
    },
    next(year, month, week) {
      console.log(year, month, week);
    },
    selectYear(year) {
      console.log(year);
    },
    setToday() {
      this.$refs.calendar.setToday();
    },
    dateInfo() {
      const info = this.$refs.calendar.dateInfo(2018, 8, 23);
      console.log(info);
    },
    renderer() {
      if (this.monthRange.length) {
        this.monthRange = ["2018-8", "2018-8"];
      }
      this.$refs.calendar.renderer(2018, 8); //渲染2018年8月份
    },
    select(val, val2) {
      if (this.isrange) {
        this.handelRenderValues([val, val2]);
      } else if (this.ismulti) {
        this.handelRenderValues(val);
      } else {
        this.handelRenderValues([val]);
      }
      if (
        this.where.start != new Date(val) / 1000 ||
        this.where.stop != new Date(val2) / 1000 + 24 * 60 * 60 - 1
      ) {
        this.time = "date";
        this.title = "";
        this.where.start =
          new Date(Date.parse(val[0] + "/" + val[1] + "/" + val[2])).getTime() /
          1000;
        this.where.stop =
          new Date(
            Date.parse(val2[0] + "/" + val2[1] + "/" + val2[2])
          ).getTime() /
            1000 +
          24 * 60 * 60 -
          1;
		this.timeData = val[0] + '-' + val[1] + '-' + val[2] + ' - ' + val2[0] + '-' + val2[1] + '-' + val2[2];
		console.log(this.timeData)
        this.getIndex();
      }
    },
    dateTitle: function() {
      this.current = true;
    },
    close: function() {
      this.current = false;
    },
    
  }
};
</script>
<style scoped>
.calendar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 777;
  transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.calendar-wrapper.on {
  transform: translate3d(0, 0, 0);
}
.statistical-page .wrapper .increase {
  font-size: 0.26rem;
}
.statistical-page .wrapper .increase .iconfont {
  margin-left: 0;
}
.public-wrapper-mon{margin-top: 0.96rem;padding: 0.45rem 0.25rem;}
.statistical-page .navs{box-shadow: 0 0 5px #ccc;}
.public-wrapper-mon-top{border-bottom: 1px solid #ebedf0;padding-bottom: 0.3rem;}
.public-wrapper-mon-bot{display: flex;justify-content: center;}
.public-wrapper-mon-bot>div{width: 100%;padding-top: 0.2rem;border-left: 1px solid #ebedf0;padding-left: 0.2rem;}
.public-wrapper-mon-bot>div:first-child{padding-left: 0;border-left: none;}
.public-wrapper-mon-top h2,.public-wrapper-mon-bot h2,.public-wrapper-num h2{font-size: 0.38rem;}
.public-wrapper-mon-top .gray,.public-wrapper-mon-bot .gray,.public-wrapper-num .gray{color: #999;font-size: 0.26rem;margin-top: 0.1rem;}
.public-wrapper-mon-top .waitmon,.public-wrapper-mon-bot .waitmon{font-size: 0.26rem;margin-top: 0.1rem;}
.public-wrapper-num{margin-top: 0.2rem;padding: 0.45rem 0.25rem;display: flex;justify-content: center;}
.public-wrapper-num>div{width: 100%;}
.public-wrapper-num-l>div:first-child{border-bottom: 1px solid #ebedf0;padding-bottom: 0.2rem;}
.public-wrapper-num-l>div:last-child{margin-top: 0.2rem;}
.public-wrapper-num-r{border-left: 1px solid #ebedf0;padding-left: 0.2rem;}
</style>
